// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__KHOns","bigColWidth":"Table_bigColWidth__1u8N9","biggerColWidth":"Table_biggerColWidth__1uGFy","row":"Table_row__3OvGl","col":"Table_col__GjpDu"};